import { Component, OnInit } from '@angular/core';
import { StarRatingColor } from '../components/star-rating/star-rating.component';

@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss']
})
export class ReviewComponent implements OnInit {

  constructor() { }
  rating:number = 3;
  starCount:number = 5;
  starColor:StarRatingColor = StarRatingColor.accent;
  starColorP:StarRatingColor = StarRatingColor.primary;
  starColorW:StarRatingColor = StarRatingColor.warn;
  ngOnInit(): void {
  }

  onRatingChanged(rating){
    this.rating = rating;
  }

}
